import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../../components/CustomForm/CustomSelect";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import Colors from "../../../../themes/Colors";
import Text from "../../../../components/Common/Text";
import { Form } from "../../../../components/CustomForm/FormStyles";
import {
  UserFormContainer,
  UserFormRow,
  UserFormSingleRow,
  UserFormButtonContainer,
  UserFormGroup,
} from "../../shared/FormStyles";
import UsuariosActions from "../../../../stores/usuarios/Actions";
import usePermissions from "../../../../hooks/usePermissions";

const AdministracionUsuariosCrearEditarForm = ({
  userData,
  onSubmit,
  onCancel,
  isLoading,
  rolesOptions = [],
  obtenerRecursos,
  authUserData,
}) => {
  const { canManageUsers } = usePermissions();
  const initialFormState = useMemo(
    () => ({
      username: "",
      name: "",
      lastName: "",
      department: "",
      selectedRole: "",
    }),
    []
  );

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (authUserData?.tokenStandVirtual) {
      obtenerRecursos({
        requestHeaders: {
          Authorization: `Bearer ${authUserData.tokenStandVirtual}`,
        },
      });
    }
  }, [obtenerRecursos, authUserData?.tokenStandVirtual]);

  useEffect(() => {
    if (userData && userData.username) {
      const currentRole =
        userData.perfil &&
        userData.perfil.roles &&
        userData.perfil.roles.length > 0
          ? userData.perfil.roles[0]
          : "";

      setFormData({
        username: userData.username || "",
        name: userData.name || "",
        lastName: userData.lastName || "",
        department: userData.department || "",
        selectedRole: currentRole,
      });
    } else {
      setFormData(initialFormState);
    }
  }, [initialFormState, userData]);

  const handleChange = (field) => (value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "selectedRole" && errors.selectedRole) {
      setErrors((prev) => ({ ...prev, selectedRole: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.selectedRole) {
      setErrors({ selectedRole: "Debe seleccionar un rol" });
      return;
    }

    setErrors({});
    onSubmit({
      requestData: {
        username: formData.username,
        roleId: formData.selectedRole,
      },
      requestHeaders: {
        Authorization: `Bearer ${authUserData?.tokenStandVirtual}`,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <UserFormContainer>
        <UserFormRow>
          <UserFormGroup>
            <CustomInput
              label="Nombre"
              placeholder="Nombre"
              value={formData.name}
              onChange={handleChange("name")}
              disabled={true}
            />
          </UserFormGroup>

          <UserFormGroup>
            <CustomInput
              label="Usuario"
              placeholder="Usuario"
              value={formData.username}
              onChange={handleChange("username")}
              disabled={true}
            />
          </UserFormGroup>
        </UserFormRow>

        <UserFormSingleRow>
          <UserFormGroup>
            <CustomInput
              label="Departamento"
              placeholder="Departamento"
              value={formData.department}
              onChange={handleChange("department")}
              disabled={true}
            />
          </UserFormGroup>
        </UserFormSingleRow>

        <UserFormSingleRow>
          <UserFormGroup>
            <CustomSelect
              label="Rol"
              placeholder="Seleccione un rol"
              value={formData.selectedRole}
              onChange={handleChange("selectedRole")}
              options={rolesOptions}
              showDefaultOption={true}
              className={errors.selectedRole ? "error" : ""}
            />
            {errors.selectedRole && (
              <Text
                size="14px"
                color="#dc3545"
                margin="5px 0 0 5px"
                weight="500"
              >
                {errors.selectedRole}
              </Text>
            )}
          </UserFormGroup>
        </UserFormSingleRow>

        <UserFormButtonContainer>
          <CustomButton
            type="button"
            label="Cancelar"
            bgColor={Colors.gray}
            hoverColor={Colors.darkGray}
            textColor={Colors.white}
            hoverTextColor={Colors.white}
            onClick={onCancel}
            width="130px"
            fontSize="16px"
          />

          {canManageUsers && (
            <CustomButton
              type="submit"
              label="Actualizar"
              bgColor={Colors.primaryPrimera}
              hoverColor={Colors.darkGreenPrimera}
              textColor={Colors.white}
              hoverTextColor={Colors.white}
              loading={isLoading}
              width="130px"
              fontSize="16px"
            />
          )}
          {!canManageUsers && (
            <Text size="14px" color="#999" textAlign="center" margin="10px 0">
              Solo los usuarios Master pueden gestionar usuarios
            </Text>
          )}
        </UserFormButtonContainer>
      </UserFormContainer>
    </Form>
  );
};

AdministracionUsuariosCrearEditarForm.propTypes = {
  userData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  rolesOptions: PropTypes.array,
  obtenerRecursos: PropTypes.func.isRequired,
  authUserData: PropTypes.object,
};

AdministracionUsuariosCrearEditarForm.defaultProps = {
  userData: null,
  isLoading: false,
  rolesOptions: [],
};

const mapStateToProps = (state) => ({
  rolesOptions: (state.usuarios.obtenerRecursosData?.roles || []).map(
    (role) => ({
      value: role.roleId,
      label: role.roleName,
    })
  ),
  authUserData: state.auth.authUserData,
});

const mapDispatchToProps = {
  obtenerRecursos: UsuariosActions.obtenerRecursos,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AdministracionUsuariosCrearEditarForm);
